import * as swcHelpers from '@swc/helpers';
import '@grandvisionhq/utils';
import '@grandvisionhq/graphql';
import '../../../types/product.js';
import { mapServerToSolutionsVariant } from '../variant-mappers/map-server-to-solutions-variant.js';
import { mapServerToProductBase } from './map-server-to-product-base.js';

const mapServerToSolutionsProduct = (serverProduct, slug, locale, facetConfigList, priceSegmentChannelKey)=>{
    var ref;
    if ((serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename) !== 'SolutionProduct') {
        return {
            failure: 'incorrect-typename',
            message: `Expected SolutionProduct for slug "${slug}", but got ${serverProduct === null || serverProduct === void 0 ? void 0 : serverProduct.__typename}`
        };
    }
    const variants = mapServerToSolutionsVariant(serverProduct, slug, locale, priceSegmentChannelKey);
    if (!variants || variants.length === 0) {
        return {
            failure: 'no-variants',
            message: `Cannot return Solutions product with slug: "${slug}" because it has no variants`
        };
    }
    var ref1;
    return swcHelpers.objectSpread({}, mapServerToProductBase(serverProduct, variants, facetConfigList), {
        productType: 'Solutions',
        variants,
        isExclusiveBrand: (ref1 = (ref = serverProduct.productTypeDetails) === null || ref === void 0 ? void 0 : ref.exclusiveBrand) !== null && ref1 !== void 0 ? ref1 : undefined
    });
};

export { mapServerToSolutionsProduct };
//# sourceMappingURL=map-server-to-solutions-product.js.map
